import { h } from 'preact';

const Radio = ({groupName, value, currentValue, onChange, className}) => {
  return (
    <div className={className}>
      <label>
        <input
          type="radio"
          name={groupName}
          value={value}
          checked={currentValue === value}
          onChange={onChange}
        />
        {value}x{value}
      </label>
    </div>
  )
}

export default Radio;